import { PlayLayout } from '@app/play-now/routes/PlayLayout';
import { getLayoutData, mergeMeta } from '@app/utils/remix/play-now-meta';
import { getRemixMeta } from '@play-now/video/components/Meta/PlayMetaData';
import { EmbedPage } from '@play-now/video/pages/Embed/EmbedPage';
import { MetaFunction } from '@remix-run/node';

export const meta: MetaFunction = ({ matches }) => {
  const layoutData = getLayoutData(matches);
  let metaData;
  if (layoutData.initialData.videoDetail) {
    metaData = getRemixMeta({
      config: layoutData.config,
      title: layoutData.initialData.videoDetail.title,
      allowIndexing: false,
    });
  }
  return mergeMeta({ data: { meta: metaData }, matches });
};

const EmbedPageRoute = () => (
  <PlayLayout pageId='embed'>
    <EmbedPage />
  </PlayLayout>
);

export default EmbedPageRoute;
